// 시급 변경 이력 관련 타입 정의
import { Timestamp } from 'firebase/firestore';

export enum HourlyRateUpdateType {
  FULL_UPDATE = 'fullUpdate',  // 전체 적용 (기존 스케줄 포함 모두 업데이트)
  NEW_ONLY = 'newOnly',        // 신규 적용 (새 스케줄만 적용)
}

export interface HourlyRateHistory {
  id: string;
  employeeId: string;
  previousRate: number;
  newRate: number;
  changedAt: Date;
  accountNumber: number;  // 1-5
  reason?: string;
  updateType: HourlyRateUpdateType;
  createdAt: Date;
  updatedAt: Date;
}

export interface HourlyRateHistoryFormData {
  newRate: number;
  reason?: string;
  updateType: HourlyRateUpdateType;
}




